export default __webpack_public_path__ + "static/media/Medical Order.afccf719.svg";